import type { ElementType, HTMLAttributes, ReactNode } from "react";
import "./LayoutPrimitives.scss";

type BoxProps = HTMLAttributes<HTMLElement> & {
  as?: ElementType;
  children?: ReactNode;
};

export function Box({
  as: Component = "div",
  children,
  className = "",
  ...props
}: BoxProps) {
  return (
    <Component className={`layout-box ${className}`.trim()} {...props}>
      {children}
    </Component>
  );
}
